import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox }}\n{{yield this.isActive}}",{ moduleName: "embercom/components/inbox2/common/realtime-user.hbs" })